import { findElement } from 'base/tools';

// We keep track of them here so we can close later
// without having to do a querySelectorAll and loop
let openDropdowns = [];

// Helpers be helping
const open = DOMElement => DOMElement.classList.add('open');
const close = DOMElement => DOMElement.classList.remove('open');
const isOpen = DOMElement => DOMElement.classList.contains('open');
const body = document.querySelector('body');
const closeAll = () => {
	openDropdowns.forEach(dropdown => close(dropdown));
	openDropdowns = [];
};
const closeAndUnlisten = () => {
	closeAll();
	unlisten();
};

const escapeListener = ({ keyCode, ...event }) => {
	if (keyCode !== 27) return;
	if (! openDropdowns.length) return;
	closeAndUnlisten();
};

const outsideClickListener = ({ target, ...event }) => {
	if (! openDropdowns.length) return;
	const aDropdown = findElement(target, 'dropdown');
	if (! aDropdown) return closeAndUnlisten();
	// Here we are inside a dropdown which may or may not be open already...
	const container = aDropdown.parentElement;
	handleInsideDropdownClick(container);
};

// Listens for outside clicks and escape
// also stops listening for triggering dropdowns
const listen = () => {
	body.addEventListener('keyup', escapeListener, false);
	body.addEventListener('click', outsideClickListener, false);
	body.removeEventListener('click', dropdownHandler, false);
};

// The exact reverse as listen()
const unlisten = () => {
	body.removeEventListener('keyup', escapeListener);
	body.removeEventListener('click', outsideClickListener);
	body.addEventListener('click', dropdownHandler, false);
};

// Should refactor in a cleaner way :thinking:
const handleInsideDropdownClick = container => {
	if (isOpen(container)) return closeAndUnlisten();
	closeAll();
	open(container);
	openDropdowns.push(container);
	listen();
};

const dropdownHandler = ({ target, ...event }) => {
	const theDropdown = findElement(target, 'dropdown');
	if (! theDropdown) return;
	const container = theDropdown.parentElement;
	if (! container) return;
	handleInsideDropdownClick(container);
};

const dropdowns = () => {
	body.addEventListener('click', dropdownHandler, false);
};

export default dropdowns;
